"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactLoadingPopupContent = void 0;
var React = require("react");
var webexUI_1 = require("webexUI");
var ContactLoadingPopupContent = function (_a) {
    var showErrorMessage = _a.showErrorMessage, genericErrorMessageText = _a.genericErrorMessageText;
    return (React.createElement("div", { className: "contact-form-popup__content" }, showErrorMessage ? (React.createElement("div", { className: "contact-form-popup__content" },
        React.createElement("p", null, genericErrorMessageText))) : (React.createElement("div", { className: "contact-form-popup__spinner-wrapper" },
        React.createElement(webexUI_1.Spinner, { visible: true })))));
};
exports.ContactLoadingPopupContent = ContactLoadingPopupContent;
